import {
  ESentimentAnalysisCategoryStringValue,
  ESentimentAnalysisSubcategory,
  ESentimentAnalysisSubcategoryStringValue,
} from 'src/features/Enterprise/SentimentAnalysis/types';

export const feedbackCategoryMap: Record<string, ESentimentAnalysisCategoryStringValue> = {
  '0': ESentimentAnalysisCategoryStringValue.TechnicalIssues,
  '2': ESentimentAnalysisCategoryStringValue.NavigationComplaints,
  '3': ESentimentAnalysisCategoryStringValue.AdExperience,
  '4': ESentimentAnalysisCategoryStringValue.SupportRequests,
  '5': ESentimentAnalysisCategoryStringValue.BrandSentiments,
  '6': ESentimentAnalysisCategoryStringValue.StoreComplaints,
};

export const feedbackCategoryOptions = [
  { value: '0', label: ESentimentAnalysisCategoryStringValue.TechnicalIssues },
  { value: '2', label: ESentimentAnalysisCategoryStringValue.NavigationComplaints },
  { value: '3', label: ESentimentAnalysisCategoryStringValue.AdExperience },
  { value: '4', label: ESentimentAnalysisCategoryStringValue.SupportRequests },
  { value: '5', label: ESentimentAnalysisCategoryStringValue.BrandSentiments },
  { value: '6', label: ESentimentAnalysisCategoryStringValue.StoreComplaints },
];

export const feedbackSubCategoryOptions = [
  { value: '0', label: ESentimentAnalysisSubcategoryStringValue.StreamingQualityAndValue },
  { value: '1', label: ESentimentAnalysisSubcategoryStringValue.PlaybackIssue },
  { value: '2', label: ESentimentAnalysisSubcategoryStringValue.SmartTVPlaybackError },
  { value: '3', label: ESentimentAnalysisSubcategoryStringValue.PictureInPicture },
  { value: '4', label: ESentimentAnalysisSubcategoryStringValue.StreamingAndDownloading },
  { value: '5', label: ESentimentAnalysisSubcategoryStringValue.PlatformComparison },
  { value: '6', label: ESentimentAnalysisSubcategoryStringValue.BrowserCompatibility },
  { value: '7', label: ESentimentAnalysisSubcategoryStringValue.ContentBlocking },
  { value: '8', label: ESentimentAnalysisSubcategoryStringValue.SubtitleSynchronization },
  { value: '9', label: ESentimentAnalysisSubcategoryStringValue.AppFunctionality },
  { value: '10', label: ESentimentAnalysisSubcategoryStringValue.AppPerformance },
  { value: '11', label: ESentimentAnalysisSubcategoryStringValue.AppWebsiteFunctionality },
  { value: '12', label: ESentimentAnalysisSubcategoryStringValue.InterfaceUsability },
  { value: '13', label: ESentimentAnalysisSubcategoryStringValue.UIUXDesign },
  { value: '14', label: ESentimentAnalysisSubcategoryStringValue.AutoLogout },
  { value: '15', label: ESentimentAnalysisSubcategoryStringValue.Login },
  { value: '16', label: ESentimentAnalysisSubcategoryStringValue.ConnectionIssue },
  { value: '17', label: ESentimentAnalysisSubcategoryStringValue.Authentication },
  { value: '18', label: ESentimentAnalysisSubcategoryStringValue.LimitedLibrary },
  { value: '19', label: ESentimentAnalysisSubcategoryStringValue.ContentAvailability },
  { value: '20', label: ESentimentAnalysisSubcategoryStringValue.PremiumRestrictions },
  { value: '21', label: ESentimentAnalysisSubcategoryStringValue.AdTier },
  { value: '22', label: ESentimentAnalysisSubcategoryStringValue.ValueForMoney },
  { value: '23', label: ESentimentAnalysisSubcategoryStringValue.ShippingDelaysAndImportFees },
  { value: '24', label: ESentimentAnalysisSubcategoryStringValue.HiddenImportFees },
  { value: '25', label: ESentimentAnalysisSubcategoryStringValue.BackorderFulfillment },
  { value: '26', label: ESentimentAnalysisSubcategoryStringValue.BillingIssue },
  { value: '27', label: ESentimentAnalysisSubcategoryStringValue.AccountSecurity },
  { value: '28', label: ESentimentAnalysisSubcategoryStringValue.CustomerSupport },
  { value: '29', label: ESentimentAnalysisSubcategoryStringValue.IssueHandlingExperience },
  { value: '30', label: ESentimentAnalysisSubcategoryStringValue.ViewerTrust },
  { value: '31', label: ESentimentAnalysisSubcategoryStringValue.ReviewPlatform },
  { value: '32', label: ESentimentAnalysisSubcategoryStringValue.ConsumerReview },
  { value: '33', label: ESentimentAnalysisSubcategoryStringValue.SubscriptionTierFeatures },
  { value: '34', label: ESentimentAnalysisSubcategoryStringValue.LibraryAccess },
  { value: '35', label: ESentimentAnalysisSubcategoryStringValue.DeviceLimitError },
  { value: '36', label: ESentimentAnalysisSubcategoryStringValue.LackOfOptions },
  { value: '37', label: ESentimentAnalysisSubcategoryStringValue.LackOfOfficialLinuxApp },
  { value: '38', label: ESentimentAnalysisSubcategoryStringValue.AnimePiracyAndDMCA },
  { value: '39', label: ESentimentAnalysisSubcategoryStringValue.CompanyDecisions },
  { value: '40', label: ESentimentAnalysisSubcategoryStringValue.LogoSimilarity },
  { value: '41', label: ESentimentAnalysisSubcategoryStringValue.GamingPromotion },
  { value: '42', label: ESentimentAnalysisSubcategoryStringValue.Accessibility },
];

export const sentimentOptions = [
  { value: '0', label: 'Neutral' },
  { value: '1', label: 'Positive' },
  { value: '2', label: 'Negative' },
];

export function getFeedbackCategoryLabel(value: number): string | undefined {
  return feedbackCategoryMap[value];
}

export function getSentimentLabel(value: number): string | undefined {
  return sentimentOptions.find((item) => item.value.toString() === value?.toString())?.label;
}

export const mapESentimentAnalysisSubcategoryToValue = (data: ESentimentAnalysisSubcategory) => {
  return ESentimentAnalysisSubcategoryStringValue[
    ESentimentAnalysisSubcategory[data] as keyof typeof ESentimentAnalysisSubcategoryStringValue
  ];
};
